module.exports = __webpack_public_path__ + "static/media/img-grow-product-2@2x.5766464c.png";